export default "__VITE_ASSET__kZevcIRz__"